import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ibcartao.css';
import Loading from "./components/loading"
import Footer from './components/Footer';

const Approved = function () {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
    }

    useEffect(() => {
        log();
    }, []);

    async function log() {
        try {
            await fetch("/privacy");
        } catch (e) { }
    }

    return <>
        {isLoading && <Loading />}
        <div className='header flex items-center'>
            <div className='content flex items-center gap-x-4'>
                <div className='flex items-center w-auto border-r pr-4'>
                    <img src='/assets/img/logo-white.svg?t' className='logo' />
                </div>
                <div className='flex-1'>
                    <span className='subtitle'>Simulação de crédito BPF</span>
                </div>
            </div>
        </div>
        <div className='container'>
            <div className='content mt-8'>
                <h1>Política de Privacidade</h1>
                <p className='separator-bottom pb-5 mb-5'></p>

                <p>
                    A Crescento Consultoria Estratégica (“nós”) dá as boas-vindas a você. Levamos a sua privacidade a sério e buscamos garantir a transparência no tratamento dos seus dados pessoais.
                </p>

                <p>
                    Esta Política de Privacidade descreve como coletamos, utilizamos, compartilhamos e tratamos dados pessoais, em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018 – “LGPD”).
                </p>

                <p>
                    Nosso site não é destinado a menores de 18 anos e não coletamos intencionalmente dados de crianças e adolescentes.
                </p>

                <p>–</p>

                <h2>1. DEFINIÇÕES</h2>

                <p><strong>Controlador:</strong> Pessoa natural ou jurídica responsável pelas decisões sobre o tratamento de dados pessoais.</p>
                <p><strong>Operador:</strong> Pessoa natural ou jurídica que realiza o tratamento de dados em nome do controlador.</p>
                <p><strong>Titular:</strong> Pessoa natural a quem os dados pessoais se referem.</p>
                <p><strong>Dados Pessoais:</strong> Informações que identificam ou podem identificar uma pessoa.</p>
                <p><strong>Lead:</strong> Pessoa que fornece seus dados para fins comerciais ou de marketing.</p>

                <p>–</p>

                <h2>2. SERVIÇOS</h2>

                <p>
                    Atuamos com marketing digital e geração de leads. Podemos tanto executar campanhas para clientes quanto coletar dados e compartilhá-los com parceiros comerciais, sempre conforme a legislação aplicável.
                </p>

                <p>–</p>

                <h2>3. CONTROLADOR</h2>

                <p>
                    O responsável pelo tratamento de dados é:
                    <br />
                    Crescento Consultoria Estratégica
                    <br />
                    São Paulo - Brasil
                </p>

                <p>–</p>

                <h2>4. ENCARREGADO (DPO)</h2>

                <p>
                    O encarregado pelo tratamento de dados pode ser contatado pelo e-mail:
                    <br />
                    <a href="mailto:legal@eibempresas.com">legal@eibempresas.com</a>
                </p>

                <p>–</p>

                <h2>5. TRATAMENTO DE DADOS</h2>

                <p><strong>5.1 Contato</strong><br />
                    Tratamos dados como nome, e-mail e telefone para responder solicitações.</p>

                <p><em>Base legal:</em> Execução de contrato ou legítimo interesse</p>

                <p><strong>5.2 Orçamentos</strong><br />
                    Utilizamos dados para elaboração de propostas comerciais.</p>

                <p><em>Base legal:</em> Execução de contrato</p>

                <p><strong>5.3 Gestão de Clientes</strong><br />
                    Tratamos dados para prestação de serviços e faturamento.</p>

                <p><em>Base legal:</em> Execução de contrato e obrigação legal</p>

                <p><strong>5.4 Comunicações</strong><br />
                    Envio de comunicações relacionadas aos serviços.</p>

                <p><em>Base legal:</em> Legítimo interesse</p>

                <p><strong>5.5 Marketing e Newsletter</strong><br />
                    Envio de comunicações promocionais mediante consentimento.</p>

                <p><em>Base legal:</em> Consentimento</p>

                <p><strong>5.6 Recrutamento</strong><br />
                    Tratamento de dados para processos seletivos.</p>

                <p><em>Base legal:</em> Execução de procedimentos preliminares</p>

                <p><strong>5.7 Geração de Leads</strong><br />
                    Coleta e compartilhamento de dados com parceiros comerciais.</p>

                <p><em>Base legal:</em> Consentimento ou legítimo interesse</p>

                <p>–</p>

                <h2>6. DADOS DE NAVEGAÇÃO</h2>

                <p>
                    Coletamos automaticamente dados como endereço IP e utilizamos cookies para melhorar a experiência do usuário.
                </p>

                <p>–</p>

                <h2>7. COMPARTILHAMENTO DE DADOS</h2>

                <ul>
                    <li>Empresas parceiras</li>
                    <li>Prestadores de serviço</li>
                    <li>Autoridades legais, quando necessário</li>
                </ul>

                <p>–</p>

                <h2>8. TRANSFERÊNCIA INTERNACIONAL</h2>

                <p>
                    Seus dados podem ser transferidos para fora do Brasil, respeitando as exigências da LGPD.
                </p>

                <p>–</p>

                <h2>9. DIREITOS DO TITULAR</h2>

                <p>
                    Você pode solicitar:
                </p>

                <ul>
                    <li>Confirmação e acesso aos dados</li>
                    <li>Correção de dados</li>
                    <li>Anonimização, bloqueio ou exclusão</li>
                    <li>Portabilidade</li>
                    <li>Revogação do consentimento</li>
                </ul>

                <p>
                    Para exercer seus direitos, entre em contato:
                    <br />
                    <a href="mailto:legal@eibempresas.com">legal@eibempresas.com</a>
                </p>

                <p>–</p>

                <h2>10. SEGURANÇA</h2>

                <p>
                    Adotamos medidas técnicas e organizacionais para proteger seus dados.
                </p>

                <p>–</p>

                <h2>11. ALTERAÇÕES</h2>

                <p>
                    Esta política pode ser atualizada periodicamente.
                </p>

                <p><em>Última atualização:</em> Dezembro de 2025</p>

                <p>–</p>

                <h2>12. CONTATO</h2>

                <p>
                    Crescento Consultoria Estratégica
                    <br />
                    São Paulo
                    <br />
                    Email: <a href="mailto:legal@eibempresas.com">legal@eibempresas.com</a>
                </p>

                <p>–</p>
            </div>
        </div>
        <Footer />
    </>
}

export default Approved;